export default __webpack_public_path__ + "static/media/Icon=Employee Status.643e4229.svg";